// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3Sd2O","header":"ReportDetails_header__2biW8","title":"ReportDetails_title__1OTKU","left":"ReportDetails_left__L_U4k"};